import { type SerializedPageStructure } from '@wix/document-services-types'

import {
  type DataBindingConnectionConfigByRole,
  type DataBindingRole,
} from '../types'
import { applyModifiers } from './applyModifiers'
import { assertDataBindingController } from './assertDataBindingController'
import { getComponentByVeloId } from './getComponentByVeloId'
import { modifyComponentAndControllerConnectionConfig } from './modifyComponentAndControllerConnectionConfig'
import { modifyComponentByVeloId } from './modifyComponentByVeloId'

export const modifyConnectionConfigOfComponentAndControllerWithVeloIds = <
  Role extends DataBindingRole,
>({
  page,
  componentVeloId,
  controllerVeloId,
  role,
  modifyConnectionConfig,
}: {
  page: SerializedPageStructure
  componentVeloId: string
  controllerVeloId: string
  role: Role
  modifyConnectionConfig: (
    config: DataBindingConnectionConfigByRole[Role],
  ) => DataBindingConnectionConfigByRole[Role]
}): SerializedPageStructure => {
  const component = getComponentByVeloId({
    root: page,
    veloId: componentVeloId,
  })
  const controller = getComponentByVeloId({
    root: page,
    veloId: controllerVeloId,
  })
  assertDataBindingController(controller)

  const { component: modifiedComponent, controller: modifiedController } =
    modifyComponentAndControllerConnectionConfig({
      component,
      controller,
      role,
      modifyConnectionConfig,
    })

  return applyModifiers({
    target: page,
    modifiers: {
      modifyComponent: page =>
        modifyComponentByVeloId({
          root: page,
          veloId: componentVeloId,
          modifyComponent: () => modifiedComponent,
        }),

      modifyController: page =>
        modifyComponentByVeloId({
          root: page,
          veloId: controllerVeloId,
          modifyComponent: () => modifiedController,
        }),
    },
  })
}
